export class ApiEntity<T> {
    prefix: string;
    fields: T;

    constructor(prefix: string, fields: T) {
        this.prefix = prefix;
        this.fields = fields;
    }

    getPrefixed(field: keyof T): string {
        return this.prefix + '.' + this.fields[field];
    }
}
